import { RootState } from 'app/store/rootReducer';
import { selectIsOperator } from 'app/store/data/user';
import { isCarCalculatorPath } from 'app/shared/helpers/isCarCalculatorPath';

export const getIsFormMicroCenterActive = (isOperator: boolean) =>
  !isOperator && isCarCalculatorPath(window.location.pathname);

export const selectIsFormMicroCenterActive = (state: RootState) =>
  getIsFormMicroCenterActive(selectIsOperator(state));
